import {NameInOther, Severity, Violation} from '@wix/wixstores-graphql-schema-node';

export const calcTopThreeViolations = (violations: Violation[]): Violation[] => {
  return violations?.length > 0
    ? [
        ...violations.filter(
          (violation) =>
            violation.severity === Severity.ERROR && violation.target?.other?.name === NameInOther.OTHER_DEFAULT
        ),
        ...violations.filter(
          (violation) =>
            violation.severity === Severity.WARNING && violation.target?.other?.name === NameInOther.OTHER_DEFAULT
        ),
      ]
        .slice(0, 3)
        .reverse()
    : [];
};

export const calcVisibleViolations = (violations: Violation[]): Violation[] => {
  const top3violations = calcTopThreeViolations(violations);
  return [
    ...top3violations,
    ...violations.filter(
      (violation) => violation.severity === Severity.ERROR && Boolean(violation.target?.lineItem?.id)
    ),
    ...violations.filter(
      (violation) => violation.severity === Severity.WARNING && Boolean(violation.target?.lineItem?.id)
    ),
  ];
};
